import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CaratageForm from '../../../../components/masters/styles/caratage/CaratageForm';
import CaratageTable from '../../../../components/masters/styles/caratage/CaratageTable';
import { fetchCaratages, addCaratage, updateCaratage, deleteCaratage, setCaratageEdit, clearCaratageEdit } from '../../../../redux/actions/masters/styles/caratage/caratageAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .caratage-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .caratage-form, .caratage-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const CaratagePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingCaratage } = useSelector(state => state.caratage || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchCaratages());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearCaratageEdit());
  };

  const handleSubmit = async (form) => {
    if (editingCaratage && editingCaratage.id) {
      await dispatch(updateCaratage(editingCaratage.id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addCaratage(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (caratage) => {
    dispatch(setCaratageEdit(caratage));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteCaratage(id));
  };

  const handleCancel = () => {
    dispatch(clearCaratageEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      p => p.caratage_code === code && (!excludeId || p.id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="caratage-flex">
        <div style={tableContainer} className="caratage-table">
          <CaratageTable
            onNew={handleFormReset}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="caratage-form">
          <CaratageForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingCaratage={editingCaratage}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default CaratagePage; 